export default __webpack_public_path__ + "static/media/commercial.ea9ddf91.png";